import Sortable from 'sortablejs'

let vxe = {

  /**
   * 初始化表头拖拽排序
   * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/other/sortableColumn
   * @param vm {Vue}
   * @param gridRefName {string} vxeGrid ref名称
   */
  initColumnDragging: function (vm, gridRefName) {
    vm.$nextTick(() => {
      let gridRef = vm.$refs[gridRefName]
      vm.sortableInstance = Sortable.create(gridRef.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
        handle: '.vxe-header--column:not(.col--fixed)',
        onEnd: ({item, newIndex, oldIndex}) => {
          let {fullColumn, tableColumn} = gridRef.getTableColumn()
          let targetThElem = item
          let wrapperElem = targetThElem.parentNode
          let newColumn = fullColumn[newIndex]
          if (newColumn.fixed) {
            // 错误的移动
            if (newIndex > oldIndex) {
              wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex])
            }
            else {
              wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem)
            }
            return this.$XModal.message({message: '固定列不允许拖动！', status: 'error'})
          }
          // 转换真实索引
          let oldColumnIndex = gridRef.getColumnIndex(tableColumn[oldIndex])
          let newColumnIndex = gridRef.getColumnIndex(tableColumn[newIndex])
          // 移动到目标列
          let currRow = fullColumn.splice(oldColumnIndex, 1)[0]
          fullColumn.splice(newColumnIndex, 0, currRow)
          gridRef.loadColumn(fullColumn)
        }
      })
    })
  }
}

let tableUtil = {
  vxe
}

export default tableUtil